export default __webpack_public_path__ + "static/media/LesDeeptech.28aba606.png";